<script setup lang="ts">
import GwMessage from '@/components/Messages/GwMessage.vue'
import Snackbar from '@/components/Messages/Snackbar.vue'
</script>

<template>
  <Snackbar
    ref="snackbar"
    :oneTimeOnly="true"
    localKey="analyzerV2-info_banne400"
    class="d-flex w-100"
    style="
      --position: relative;
      --clr-back: transparent;
      padding: 0;
      --close-inset: 0.125rem 0.125rem auto auto;
      max-width: 100%;
      --close-padding: 0.25rem;
      --close-size: 1rem;
    "
  >
    <GwMessage
      class="info-message no-shrink w-100"
      style="position: relative; --z-index-messages: 1"
      :message="{
        hide: false,
        icon: 'mdi-information',
        type: 'info',
      }"
    >
      <div>
        Redefining Precision: Introducing HH Analyzer 2.0 -
        <a
          style="color: white; text-decoration: underline !important"
          href="https://blog.gtowizard.com/redefining-precision-introducing-hh-analyzer-2-0-and-much-more/"
          target="_blank"
        >
          Learn more here </a
        >.
      </div>
    </GwMessage>
  </Snackbar>
</template>

<style lang="scss" scoped>
.info-message {
  --back-opacity: 0.5;
  --back-padding: 0.25rem 1rem;
  --font-icon: 1.25rem;
  --gap: 0.5rem;
  --font-size: 0.875rem;
  --close-font-size: 2rem;
  border: 1px solid var(--clr-back);
  font-weight: 600;
}
</style>
